<template>
  <div>
    <shipblu-table
     :sst="true"
      multiple
      v-model="selected"
      :max-items="maximumItems"
      pagination
      :data="data"
      :tableLoader="promoLoading"
    >
      
      <template slot="thead">
        <shipblu-th>{{$t('Status')}}</shipblu-th>
        <shipblu-th>{{$t('Code')}}</shipblu-th>
        <shipblu-th>{{$t('Scope')}}</shipblu-th>
        <shipblu-th>{{$t('Service Types')}}</shipblu-th>
        <shipblu-th>{{$t('Auto Apply')}}</shipblu-th>
        <shipblu-th>{{$t('Start Date')}}</shipblu-th>
        <shipblu-th>{{$t('Expiry Date')}}</shipblu-th>
        <shipblu-th>{{$t('Units')}}</shipblu-th>
        <shipblu-th>{{$t('Value')}}</shipblu-th>
        <shipblu-th>{{$t('No. Merchants')}}</shipblu-th>
        <shipblu-th>{{$t('Total Usage Count')}}</shipblu-th>
        <shipblu-th>{{$t('Total Usage Value')}}</shipblu-th>
        <shipblu-th v-if="$store.state.AppActiveUser.userRole === 'growth-hacker'">{{$t('Actions')}}</shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td :data="data[indextr].status">
            <div class="m-auto flex items-center justify-center font-semibold">
              <span class="capitalize" :class="new Date(data[indextr].limits.expiry_date) >= new Date() ? 'text-green' : 'text-red'">
                {{ new Date(data[indextr].limits.expiry_date) >= new Date() ? 'Active' : 'Expired' }}
              </span>
            </div>
          </shipblu-td>

          <shipblu-td :data="data[indextr].code">
              {{ data[indextr].code }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].scope">
            {{ data[indextr].scope }}
          </shipblu-td>
          
          <shipblu-td :data="data[indextr].serviceTypes">
            <span v-for="item in data[indextr].qualifier.service_types" :key="item.index">{{ item }}<br> </span>
          </shipblu-td>

          <shipblu-td :data="data[indextr].autoApply">
            {{ data[indextr].auto_apply }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].startDate">
            {{ data[indextr].limits.start_date }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].expiryDate">
            {{ data[indextr].limits.expiry_date }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].units">
            {{ data[indextr].unit }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].value">
            {{ Number(data[indextr].value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
          </shipblu-td>
          
          <shipblu-td :data="data[indextr].value">
            {{ data[indextr].total_usage_merchants_count }} / {{ data[indextr].qualifier.merchants.length }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].value">
            {{ data[indextr].total_usage_count }} / {{ data[indextr].limits.total_usage_count }}
          </shipblu-td>

          <shipblu-td :data="data[indextr].value">
            {{ data[indextr].total_usage_value }} / {{ data[indextr].limits.total_cash_value }}
          </shipblu-td>

          <shipblu-td v-if="$store.state.AppActiveUser.userRole === 'growth-hacker'">
            <vs-dropdown
              vs-trigger-click
              class="dd-actions cursor-pointer"
              @click="selected = []"
            >
              <vs-button
                type="border"
                size="small"
                icon-pack="feather"
                icon="icon-more-horizontal"
                class="mr-2"
              >
              </vs-button>
              <vs-dropdown-menu style="width: 190px">
                <vs-dropdown-item
                  @click="openPromoAndExceptionModal(data[indextr])"
                >
                  <span class="flex items-center">
                    <feather-icon
                      icon="EditIcon"
                      svgClasses="h-4 w-4"
                      class="mr-2"
                    />
                    <span>{{$t('Edit')}}</span>
                  </span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    
  </div>
</template>

<script>
import ShipbluTable from '../../../layouts/components/ShipBluTable.vue'
import ShipbluTr from '../../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../../layouts/components/ShipBluTd.vue'
import ShipbluPagination from '../../../layouts/components/ShipbluPagination.vue'

export default {
  props: ['data', 'currentPage', 'totalRows', 'promoLoading'],
  data () {
    return {
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: []
    }
  },
  watch: {
    currentPage () {
      this.$emit('currentPage', this.currentPage)
    }
  },
  methods: {
    openPromoAndExceptionModal (data) {
      this.$emit('type', 'Edit')
      this.$emit('codeData', data)
      this.$emit('promoAndExceptionModal', true)
    }
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    ShipbluPagination
  },
  created () {
  }
}
</script>